import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { VoyagePartComponent } from '../voyage-part-component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MiscDocument, Voyage } from 'src/app/generated/services/transportation/voyages/voyage';
import { VoyageServiceSpa } from 'src/app/generated/services/transportation/voyages/voyageSpa';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialChunkFileUploadComponent } from 'src/app/shared/components/material-file-uploader/material-chunk-file-upload.component';
import { DocumentReference } from 'src/app/documents/documents.service';
import { MaterialPdfViewerComponent } from 'src/app/shared/components/material-pdf-viewer/material-pdf-viewer.component';
import { MessageLevel, PgMessagesService } from 'src/app/shared/services/pg-messages.service';
import { MaterialPgButtonComponent } from 'src/app/shared/components/material-pg-button/material-pg-button.component';
import { LookupServiceSpa } from 'src/app/generated/services/lookups/lookupSpa';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';

@Component({
  selector: 'app-misc-document',
  templateUrl: './misc-document.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MaterialChunkFileUploadComponent,
    MaterialPdfViewerComponent,
    MaterialPgButtonComponent,
    MaterialAutoCompleteComponent
  ]
})
export class MiscDocumentComponent implements OnInit, VoyagePartComponent {
  @Output() changed: EventEmitter<Voyage> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();

  key = 'Misc-Document';
  _uploadedFileId!: string;
  _selectedVoyage!: Voyage;
  _newUploadedFileId!: string;
  expectedVersion?: number;

  miscDocument: MiscDocument;
  documentTypes: string[] = [];
  doc?: DocumentReference;

  @Input() set fileId(value: string) {
    this._uploadedFileId = value;
  }
  @Input() set data(value: any) {
    this._selectedVoyage = value as Voyage;
  }
  @Input() set updatedFileId(value: string) {
    this._newUploadedFileId = value;
  }
  constructor(
              private _voyagesService: VoyageServiceSpa,
              private _activatedRoute: ActivatedRoute,
              private _pgMessagesService: PgMessagesService,
              private _router: Router,
              private _lookupServiceSpa: LookupServiceSpa) {
    this.miscDocument = MiscDocument.create();
  }

  ngOnInit() {
    this._activatedRoute.paramMap.subscribe(async p => {
      this._activatedRoute.queryParams.subscribe(p => {
        this._uploadedFileId = p['fileId'];
      });
      const result = await this._voyagesService.getVoyageById({
        id: p.get('id') || ''
      });
      this._selectedVoyage = result.data || Voyage.create();
      this.expectedVersion = result.version;
      this._lookupServiceSpa.getLookupItems({categoryName: 'voyage_miscellaneous_documents'}).then(d => {
        this.documentTypes = d.items.map(d1 => d1.values[0]);
      });
    });
  }

  saveMiscDocument() {
    if (this._selectedVoyage.miscDocuments) {
      this._selectedVoyage.miscDocuments.push(this.miscDocument);
    } else {
      this._selectedVoyage.miscDocuments = [this.miscDocument];
    }
    this.updateVoyage(this._selectedVoyage);
  }
  updateVoyage(voyage: Voyage) {
    this._voyagesService.updateVoyage({data: voyage, expectedVersion: this.expectedVersion || 0}).then(() => {
      this._pgMessagesService.publishMessage({
        level: MessageLevel.Info,
        message: `Updated voyage ${voyage.shipVoyageNo} for ${voyage.vesselName}`,
        topic: 'Voyage'
      });
      this._router.navigate(['vessels/voyage', voyage.id], {
        queryParams: {
          t: new Date().getTime()
        }
      }).then();
    });
  }
  uploadDocument(docReference: DocumentReference) {
    this.miscDocument.fileId = docReference.id;
  }
  deleteMiscDocument() {
    if (confirm('Are you sure to delete this document')) {
      const i = this._selectedVoyage.miscDocuments.findIndex(m => m.fileId === this.miscDocument.fileId);
      this._selectedVoyage.miscDocuments.splice(i, 1);
      this.changed.emit(this._selectedVoyage);
    }
  }
  backToVoyage(){
    this._router.navigate(['/vessels/voyage/', this._selectedVoyage?.id,]);
  }
  miscDocumentTypeFormatter(documentType: string): string {
    return documentType;
  }
}
